import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import WorkflowDetail from './WorkflowDetail';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
export default class ListWorkflow extends Component {
  static propTypes = {
    workflows: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  render() {
    const { workflows, showWorkflowDeleteLoader, projectId, collection, actions, version } =
      this.props;
    if (workflows && workflows.length > 0) {
      return (
        <Accordion allowZeroExpanded>
          {workflows.map((workflow, index) => (
            <AccordionItem key={index}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <i className={`wb`}></i> <strong>{workflow.name}</strong>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <WorkflowDetail
                  key={index}
                  workflow={workflow}
                  version={version}
                  showWorkflowDeleteLoader={showWorkflowDeleteLoader}
                  projectId={projectId}
                  collection={collection}
                  actions={actions}
                />
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      );
    } else
      return (
        <div>
          <h5 className="text-center">No Workflows!</h5>
        </div>
      );
  }
}
